export function scroller(target, duration, easing) {
  const scrollMax = document.documentElement.getBoundingClientRect().height - $(window).height();
  if (scrollMax >= target) {
    $('html,body').animate({
      scrollTop: target
    }, duration, easing);
  } else {
    $('html,body').animate({
      scrollTop: scrollMax
    }, duration, easing);
  }
  return false;
}